import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { socialExportPublishMessages } from './social-export-publish-messages';

/**
 * Warning when the station has connected accounts but none are available for publishing this content.
 */
export function SocialExportNoPlatformsAlert() {
  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <FormattedMessage {...socialExportPublishMessages.panoramaNoConnectedPlatforms} />
    </Alert>
  );
}
